module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#user-square",
      toString: function () {
        return this.url;
      }
    }